var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { BillingService } from '../billing/billing.service';
import { AppUtil } from '../app.service';
import { ActivatedRoute } from '@angular/router';
import { StartupService } from '../common/startup.service';
var CreditsComponent = /** @class */ (function () {
    function CreditsComponent(billingService) {
        this.billingService = billingService;
        this.showArrears = false;
    }
    CreditsComponent.prototype.ngOnInit = function () {
        // console.log('Initial count : ' + localStorage.getItem('count'));
        this.dismissRequest = Number(localStorage.getItem('count'));
        // console.log('Dismiss Request : ' + this.dismissRequest);
        if (this.dismissRequest === 0) {
            this.getCredits();
        }
    };
    // Getting credits details to check whether there is any pending.
    CreditsComponent.prototype.getCredits = function () {
        /*  if (!localStorage.getItem('credits')) {
            console.log(localStorage.getItem('credits'));
            this.billingService.getCredits().subscribe((res) => {
              console.log('billing : ' + JSON.stringify(res));
              this.creditsStatus = res.credits;
              console.log('CreditStatus : ' + this.creditsStatus);
              localStorage.setItem('credits', this.creditsStatus); // Storing credits data in local storage.
    
              localStorage.setItem('count', '0');
    
              console.log('Dismiss Request : ' + this.dismissRequest);
    
              if (Number(localStorage.getItem('credits')) > 0) {
                this.showArrears = true;
                console.log('Arrears : ' + this.showArrears);
              }
            });
          } else {
            if (Number(localStorage.getItem('credits')) > 0) {
              this.creditsStatus = localStorage.getItem('credits');
              this.showArrears = true;
              console.log('Arrears : ' + this.showArrears);
            }
          }*/
        if (Number(localStorage.getItem('credits')) > 0) {
            this.showArrears = true;
            // console.log('Arrears : ' + this.showArrears);
        }
    };
    CreditsComponent.prototype.clear = function () {
        this.dismissRequest++;
        // console.log('Dismiss Request : ' + this.dismissRequest);
        localStorage.setItem('count', this.dismissRequest.toString());
        this.showArrears = false;
    };
    CreditsComponent = __decorate([
        Component({
            selector: 'app-credits',
            template: require("./credits.component.html"),
            styles: [require("./../global-css/global.component.scss")]
        }),
        __metadata("design:paramtypes", [BillingService])
    ], CreditsComponent);
    return CreditsComponent;
}());
export { CreditsComponent };
// @ts-ignore
var LogoComponent = /** @class */ (function () {
    function LogoComponent(appUtil, route, startup) {
        this.route = route;
        this.startup = startup;
        this.titleImg = this.startup.nIcon;
        this.isPartner = localStorage.getItem('isPartner') === 'true' ? true : false;
        this.whiteLabelling = localStorage.getItem('isWhiteLabeling');
        this.merchantLogo = localStorage.getItem('merchantLogo');
        this.dashboardLogo = localStorage.getItem('dashboardLogo');
        appUtil.setAppFavicon('appIcon', this.titleImg);
    }
    Object.defineProperty(LogoComponent.prototype, "logoChanged", {
        set: function (message) {
            this.titleImg = message;
        },
        enumerable: true,
        configurable: true
    });
    LogoComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.isPartner) {
            this.titleImg = this.merchantLogo;
        }
        else {
            this.route.params.subscribe(function () {
                _this.domain = window.location.href.replace(/(https?:\/\/)?(www.)?/i, '');
                _this.domainName = _this.domain.split('.')[1];
                if (_this.whiteLabelling === 'true') {
                    _this.titleImg = _this.dashboardLogo;
                }
                else {
                    _this.titleImg = _this.titleImg;
                }
            });
            this.titleImg = this.titleImg;
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], LogoComponent.prototype, "logoChanged", null);
    LogoComponent = __decorate([
        Component({
            selector: 'app-logo',
            template: require("./logo.component.html"),
            styles: [require("./../global-css/global.component.scss")]
        }),
        __metadata("design:paramtypes", [AppUtil, ActivatedRoute, StartupService])
    ], LogoComponent);
    return LogoComponent;
}());
export { LogoComponent };



//////////////////
// WEBPACK FOOTER
// ./src/app/shared-module/credits.component.ts
// module id = ./src/app/shared-module/credits.component.ts
// module chunks = main